export default {
  companyReqs: 'Company reqs',
  finance: 'Finance',
  jobTitle: 'Job title',
  library: 'Library',
  requirements: 'Requirements'
};
